import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import { EXTRA_DATA_URL } from 'constants'

import RetractablePanel from 'components/RetractablePanel'
import Button from 'components/Button'

import EditExtraDataForm from './EditExtraDataForm'

import {
  importExtraData
} from 'scenes/VehicleDetail/components/Policy/actions'


import { statusChanged } from 'components/RequestStatus/actions'

import './styles.scss'


export class AdditionalData extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      editting: false,
      buttonProps: {
        disabled: true
      },
    }

    this._bind('_renderHeaderActions', '_renderExtraDataRow', '_handleSubmit', '_onEdit')
  }

  _onEdit(e) {
    e.preventDefault()
    this.setState({ editting : true })
  }

  _renderHeaderActions() {
    return !this.state.editting ? (
      <div className="header-icons">
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : null
  }

  _renderExtraDataRow(dataKey, index) {
    const data = this.props.extra_data[dataKey]
    return (
      <div key={index}>
        <span>{data.key}</span>
        <strong>{data.value}</strong>
      </div>
    )
  }

  _renderData() {
    return (
      <div className="AdditionalData__data">
        {
          !this.props.extra_data_order.length ? (
            <p>No hay información adicional</p>
          ) :  this.props.extra_data_order.map(this._renderExtraDataRow)
        }
      </div>
    )
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Actualizando datos...')
    request(EXTRA_DATA_URL(this.props.userId, this.props.vehicleId, this.props.policyId), {
      method: 'PUT',
      body: {
        data: Object.values(this.props.extra_data)
      }
    })
    .then((res) => {
      this.props.importExtraData(res.data)
      this.props.updateRequestStatus(res.status, res.message)
      this.setState({ editting: false })
    })
    .catch((err) => {
      console.log(err)
      this.props.updateRequestStatus('error', 'No pudímos actualizar los datos')
    })

  }

  _renderEditForm() {
    return (
      <div>
        <form onSubmit={this._handleSubmit} className="AdditionalData__form">
          <EditExtraDataForm />
          <Button type="submit" size="small">Actualizar</Button>
        </form>
      </div>
    )
  }

  render() {
    return (
      <RetractablePanel
        ref={(panel) => this.panel = panel}
        name="Datos adicionales"
        actionButtons={this._renderHeaderActions()}
        isToggle={false}
      >
        { this.state.editting ? this._renderEditForm() : this._renderData() }
      </RetractablePanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    extra_data: state.policyVehicleDetail.get('extra_data').toJS(),
    extra_data_order: state.policyVehicleDetail.get('extra_data_order').toArray()
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    importExtraData: (extraData) => dispatch(importExtraData(extraData))
  }
}

AdditionalData.propTypes = {
  userId: PropTypes.string.isRequired,
  vehicleId: PropTypes.string.isRequired,
  policyId: PropTypes.number.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalData)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/AdditionalData/index.js